<div class="active-shopping-cart-details">
  @if (!loading) {
    <div class="shopping-cart-name">
      @if (!readonly) {
        <faro-inline-edit-field
          placeholder="Warenkorb-Name"
          [iconAltText]="'Warenkorb-Name ändern'"
          [displayString]="shoppingCartInfo.name"
          (displayStringChanged)="onShoppingCartNameChanged($event)"
        ></faro-inline-edit-field>
      }
    </div>
    @if (readonly) {
      <h2 class="preview-cart-name" [ngClass]="{ 'empty-string': !shoppingCartInfo.name }">
        {{ shoppingCartInfo.name ? shoppingCartInfo.name : "Warenkorb-Name" }}
      </h2>
    }
    <div class="status">{{ getStatusDisplayString(shoppingCartInfo.status) }}</div>
    @if (shoppingCartInfo.isSizeLimitExceeded) {
      <div class="size-warning">
        <img src="assets/icons/warning-icon.svg" alt="" /> Maximale Grösse überschritten
      </div>
    }
    <div class="double-column info-group">
      <div class="label">Erstelldatum</div>
      <div class="label">Nummer</div>
      <div class="value">{{ shoppingCartInfo.creationDate | date: "dd.MM.yyyy" }}</div>
      <div class="value">{{ shoppingCartInfo.number }}</div>
    </div>
    @if (readonly && shoppingCartInfo.status !== 'UnderConstruction') {
      @if (readonly) {
        <div class="info-group">
          <div class="label">E-Mail</div>
          <div class="value">{{ shoppingCartInfo.eMail }}</div>
        </div>
      }
      @if (readonly) {
        <div class="info-group">
          <div class="label">Export-Ziel</div>
          <div class="value">{{ exportDeviceDisplayString() }}</div>
        </div>
      }
      @if (readonly) {
        <div class="info-group">
          <div class="label">Export-Datum</div>
          <div class="value">{{ shoppingCartInfo.exportDate | date: "dd.MM.yyyy" }}</div>
        </div>
      }
    }
  }
  @if (loading) {
    <div class="loading-container">
      <p-progressSpinner strokeWidth="2" animationDuration="5s" styleClass="custom-spinner"></p-progressSpinner>
    </div>
  }
</div>
<hr class="divider" />
<div class="active-shopping-cart-details">
  <div class="shopping-cart-input-field search-field-container">
    <label>Produktions-ID</label>
    <div class="input-field">
      <input [placeholder]="readonly ? 'keine PID' : 'PID eingeben'"
        [(ngModel)]="shoppingCartInfo.productionId"
        (input)="onPidChanged(shoppingCartInfo.productionId)"
        type="text"
        pInputText
        [readonly]="readonly" />
      </div>
    </div>
    <div class="shopping-cart-input-field search-field-container">
      <label>Fassungs-ID</label>
      <div class="input-field">
        <input [placeholder]="readonly ? 'keine FID' : 'FID eingeben'"
          [(ngModel)]="shoppingCartInfo.fassungsId"
          (input)="onFidChanged(shoppingCartInfo.fassungsId)"
          type="text"
          pInputText
          [readonly]="readonly" />
        </div>
      </div>
    </div>
